const GET_INVOICES_REQUEST = 'GET_INVOICES_REQUEST';
const GET_INVOICE_REQUEST = 'GET_INVOICE_REQUEST';
const CREATE_INVOICE_REQUEST = 'CREATE_INVOICE_REQUEST';
const UPDATE_INVOICE_REQUEST = 'UPDATE_INVOICE_REQUEST';
const SEND_INVOICE_REQUEST = 'SEND_INVOICE_REQUEST';
const CANCEL_INVOICE_REQUEST = 'CANCEL_INVOICE_REQUEST';
const UPDATE_INVOICE_STATUS_REQUEST = 'UPDATE_INVOICE_STATUS_REQUEST';
const CREATE_CREDIT_MEMO_REQUEST = 'CREATE_CREDIT_MEMO_REQUEST';
const EXPORT_INVOICES_IIF_REQUEST = 'EXPORT_INVOICES_IIF_REQUEST';
const GENERATE_LAST_MONTH_INVOICES_REQUEST = 'GENERATE_LAST_MONTH_INVOICES_REQUEST';
const SEND_INVOICE_TO_GATEWAY_REQUEST = 'SEND_INVOICE_TO_GATEWAY_REQUEST';
const DELETE_INVOICE_REQUEST = 'DELETE_INVOICE_REQUEST';
const RECORD_CLIENT_PAYMENT_REQUEST = 'RECORD_CLIENT_PAYMENT_REQUEST';
const UPDATE_INVOICE_LINE_ITEMS_REQUEST = 'UPDATE_INVOICE_LINE_ITEMS_REQUEST';
const GET_INVOICES_BY_BILLING_ENTITIES_REQUEST = 'GET_INVOICES_BY_BILLING_ENTITIES_REQUEST';
const GET_CLIENTS_WITH_RECENT_INVOICES_REQUEST = 'GET_CLIENTS_WITH_RECENT_INVOICES_REQUEST';
const GET_INACTIVE_CLIENTS_REQUEST = 'GET_INACTIVE_CLIENTS_REQUEST';
const GET_INVOICE_SUMMARY_REQUEST = 'GET_INVOICE_SUMMARY_REQUEST';
const GET_CLIENT_BILLING_OVERVIEW_REQUEST = 'GET_CLIENT_BILLING_OVERVIEW_REQUEST';
const SEND_ALL_DRAFT_INVOICES_REQUEST = 'SEND_ALL_DRAFT_INVOICES_REQUEST';
const GET_INVOICE_ORPHANS_REQUEST = 'GET_INVOICE_ORPHANS_REQUEST';
const ADD_INVOICE_ORPHANS_REQUEST = 'ADD_INVOICE_ORPHANS_REQUEST';
const GET_PDF_TEMPLATE_CONFIG_REQUEST = 'GET_PDF_TEMPLATE_CONFIG_REQUEST';
const SAVE_PDF_TEMPLATE_CONFIG_REQUEST = 'SAVE_PDF_TEMPLATE_CONFIG_REQUEST';
const UPLOAD_PDF_TEMPLATE_REQUEST = 'UPLOAD_PDF_TEMPLATE_REQUEST';
const DOWNLOAD_INVOICE_PDF_REQUEST = 'DOWNLOAD_INVOICE_PDF_REQUEST';
const GET_INTUIT_CONNECTION_STATUS_REQUEST = 'GET_INTUIT_CONNECTION_STATUS_REQUEST';
const GET_INTUIT_CUSTOMERS_REQUEST = 'GET_INTUIT_CUSTOMERS_REQUEST';
const GET_INVOICED_PERIOD_FOR_DATE_REQUEST = 'GET_INVOICED_PERIOD_FOR_DATE_REQUEST';
const GET_UNBILLED_REPORT_REQUEST = 'GET_UNBILLED_REPORT_REQUEST';
const GET_BILLING_PREVIEW_REQUEST = 'GET_BILLING_PREVIEW_REQUEST';
const GET_INVOICE_NUMBER_PREVIEW_REQUEST = 'GET_INVOICE_NUMBER_PREVIEW_REQUEST';

export const getInvoices = (start, limit, status, callback, opts) => {
    return {
        type: GET_INVOICES_REQUEST,
        payload: { start, limit, status, callback, opts }
    }
}

export const getInvoice = (id, callback) => {
    return {
        type: GET_INVOICE_REQUEST,
        payload: { id, callback }
    }
}

export const createInvoice = (invoice, callback) => {
    return {
        type: CREATE_INVOICE_REQUEST,
        payload: { invoice, callback }
    }
}

export const updateInvoice = (id, invoice, callback) => {
    return {
        type: UPDATE_INVOICE_REQUEST,
        payload: { id, invoice, callback }
    }
}

export const sendInvoice = (id, callback) => {
    return {
        type: SEND_INVOICE_REQUEST,
        payload: { id, callback }
    }
}

export const cancelInvoice = (id, callback) => {
    return {
        type: CANCEL_INVOICE_REQUEST,
        payload: { id, callback }
    }
}

export const updateInvoiceStatus = (id, status, callback) => {
    return {
        type: UPDATE_INVOICE_STATUS_REQUEST,
        payload: { id, status, callback }
    }
}

export const createCreditMemo = (id, creditData, callback) => {
    return {
        type: CREATE_CREDIT_MEMO_REQUEST,
        payload: { id, creditData, callback }
    }
}

export const exportInvoicesIif = (opts, callback) => {
    return {
        type: EXPORT_INVOICES_IIF_REQUEST,
        payload: { opts, callback }
    }
}

export const generateInvoicesForMonth = (month, callback, dueDate, invoiceDate) => {
    return {
        type: GENERATE_LAST_MONTH_INVOICES_REQUEST,
        payload: { month, dueDate, invoiceDate, callback }
    }
}

export const sendInvoiceToGateway = (id, callback) => {
    return {
        type: SEND_INVOICE_TO_GATEWAY_REQUEST,
        payload: { id, callback }
    }
}

export const deleteInvoice = (id, callback) => {
    return {
        type: DELETE_INVOICE_REQUEST,
        payload: { id, callback }
    }
}

export const recordClientPayment = (invoiceId, paymentData, callback) => {
    return {
        type: RECORD_CLIENT_PAYMENT_REQUEST,
        payload: { invoiceId, paymentData, callback }
    }
}

export const updateInvoiceLineItems = (id, lineItems, callback) => {
    return {
        type: UPDATE_INVOICE_LINE_ITEMS_REQUEST,
        payload: { id, lineItems, callback }
    }
}

export const getInvoicesByBillingEntities = (callback) => {
    return {
        type: GET_INVOICES_BY_BILLING_ENTITIES_REQUEST,
        payload: { callback }
    }
}

export const getClientsWithRecentInvoices = (callback) => {
    return {
        type: GET_CLIENTS_WITH_RECENT_INVOICES_REQUEST,
        payload: { callback }
    }
}

export const getInactiveClients = (callback) => {
    return {
        type: GET_INACTIVE_CLIENTS_REQUEST,
        payload: { callback }
    }
}

export const getInvoiceSummary = (callback) => {
    return {
        type: GET_INVOICE_SUMMARY_REQUEST,
        payload: { callback }
    }
}

export const getClientBillingOverview = (clientId, start, limit, callback) => {
    return {
        type: GET_CLIENT_BILLING_OVERVIEW_REQUEST,
        payload: { clientId, start, limit, callback }
    }
}

export const sendAllDraftInvoices = (opts, callback) => ({
    type: SEND_ALL_DRAFT_INVOICES_REQUEST,
    payload: { opts, callback }
});

export const getInvoiceOrphans = (invoiceId, callback, opts) => ({
    type: GET_INVOICE_ORPHANS_REQUEST,
    payload: { invoiceId, callback, opts }
});

export const addInvoiceOrphans = (invoiceId, body, callback) => ({
    type: ADD_INVOICE_ORPHANS_REQUEST,
    payload: { invoiceId, body, callback }
});

export const getPdfTemplateConfig = (callback) => ({
    type: GET_PDF_TEMPLATE_CONFIG_REQUEST,
    payload: { callback }
});

export const savePdfTemplateConfig = (config, callback) => ({
    type: SAVE_PDF_TEMPLATE_CONFIG_REQUEST,
    payload: { config, callback }
});

export const uploadPdfTemplate = (formData, callback) => ({
    type: UPLOAD_PDF_TEMPLATE_REQUEST,
    payload: { formData, callback }
});

export const downloadInvoicePdf = (invoiceId, callback) => ({
    type: DOWNLOAD_INVOICE_PDF_REQUEST,
    payload: { invoiceId, callback }
});

export const getIntuitConnectionStatus = (callback) => ({
    type: GET_INTUIT_CONNECTION_STATUS_REQUEST,
    payload: { callback }
});

export const getIntuitCustomers = (callback) => ({
    type: GET_INTUIT_CUSTOMERS_REQUEST,
    payload: { callback }
});

export const getInvoicedPeriodForDate = ({ date, projectId, accountId }, callback) => ({
    type: GET_INVOICED_PERIOD_FOR_DATE_REQUEST,
    payload: { date, projectId, accountId, callback }
});

export const getUnbilledReport = (month, callback) => ({
    type: GET_UNBILLED_REPORT_REQUEST,
    payload: { month, callback }
});

export const getBillingPreview = (clientId, month, callback) => ({
    type: GET_BILLING_PREVIEW_REQUEST,
    payload: { clientId, month, callback }
});

export const getInvoiceNumberPreview = (pattern, callback) => ({
    type: GET_INVOICE_NUMBER_PREVIEW_REQUEST,
    payload: { pattern, callback }
});
